var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedPromptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#00A8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.541 17.6552C32.9742 17.9408 33.0938 18.5234 32.8082 18.9566L24.1578 32.0777C24.0013 32.315 23.7457 32.4687 23.4627 32.4957C23.1797 32.5228 22.8997 32.4201 22.7011 32.2167L18.3032 27.7097C17.9409 27.3384 17.9481 26.7436 18.3195 26.3813C18.6908 26.0189 19.2855 26.0262 19.6479 26.3975L23.2312 30.0697L31.2396 17.9224C31.5252 17.4893 32.1078 17.3696 32.541 17.6552Z",
    fill: "#00A8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedPromptIcon);
export default __webpack_public_path__ + "static/media/completed-prompt-icon.823ee91c7e7676d9a0772438d134a1cf.svg";
export { ForwardRef as ReactComponent };